export const CURRENCY = {
  USA: { code: "USD", symbol: "$" },
  UK: { code: "GBP", symbol: "£" },
  EU: { code: "EUR", symbol: "€" },
  Ireland: { code: "EUR", symbol: "€" },
};
export const SYMBOL = { USD: "$", GBP: "£", EUR: "€" };
export const FX_TO_GBP = { GBP: 1.0, EUR: 0.855, USD: 0.78 };

export const money = (amount, code = "GBP", digits = 2) =>
  `${SYMBOL[code] || ""}${Number(amount || 0).toLocaleString("en-GB", { minimumFractionDigits: digits, maximumFractionDigits: digits })}`;

export const num = (n) => Number(n || 0).toLocaleString("en-GB");

export const convert = (amount, from, to) => (amount * FX_TO_GBP[from]) / FX_TO_GBP[to];

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "—");
export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");

export const REGION_FLAG = { USA: "🇺🇸", UK: "🇬🇧", EU: "🇪🇺", Ireland: "🇮🇪" };

export function downloadCsv(filename, headers, rows) {
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const csv = [headers.map(esc).join(","), ...rows.map((r) => r.map(esc).join(","))].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}
